import { combineReducers } from '@reduxjs/toolkit';
import { reducer as authReducer } from 'src/slices/auth';
import { reducer as alertReducer } from 'src/slices/alert';
import { reducer as userReducer } from 'src/slices/user';
import { reducer as loadingReducer } from 'src/slices/isLoading';
import { reducer as toggleReducer } from 'src/slices/toggle';
import { reducer as sessionDurationReducer } from 'src/slices/timeOut';
import { reducer as resourceReducer } from 'src/slices/resource';
import { reducer as transferCreditReducer } from 'src/slices/transferCredit-Rates';
import { reducer as verifyCallerReducer } from 'src/slices/verifyCallerID';

const rootReducer = combineReducers({
  auth: authReducer,
  alert: alertReducer,
  user: userReducer,
  loading: loadingReducer,
  toggle: toggleReducer,
  sessionDuration: sessionDurationReducer,
  transferCredit: transferCreditReducer,
  resources: resourceReducer,
  verifyCaller: verifyCallerReducer
});

export default rootReducer;
